import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Link,
  OutlinedInput,
  TextField,
  Typography
} from "@mui/material";
import React, { useState } from "react";
import LoginPageImage from "../../Assests/LoginPageImage.svg";
import loginFooter from "../../Assests/loginFooter.svg";
import companyLogo from "../../Assests/CompanyLogo.svg";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import "./Loginpage.css";
import toast, { Toaster } from "react-hot-toast";
import { forgotPassword } from "../../API Service/apiService";
import Loader from "../Common/Loader.js";
const Loginpage = () => {
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  // const handleLogin = (e) => {
  //   e.preventDefault(); // Prevent form submission
  //   localStorage.setItem("token", "1234");
  // };

  const [formData, setFormData] = useState({
    accessKey: "",
    email: ""
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { accessKey, email } = formData;

    // Validation
    if (!accessKey || !email) {
      toast.error("Both Access Key and Email are required.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    try {
      const response = await forgotPassword(formData);
      console.log("response", response);
      if (response.status === "success") {
        toast.success(response.message || "Password sent to your email.");
      } else {
        toast.error(response.message || "Failed to retrieve password.");
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred while processing your request.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Grid container className="body">
        {/* left side */}
        <Grid container md={5}>
          <Grid
            container
            gap={1}
            className="loginForm"
            direction="column"
            alignItems="center"
          >
            <Grid item sx={{ marginTop: "5px", padding: 0 }}>
              <img
                src={companyLogo}
                alt="Company Logo"
                className="companyLogo"
              />
            </Grid>
            <Grid item sx>
              <Typography variant="h6">Get Your Password</Typography>
            </Grid>

            <Grid
              container
              justifyContent={"center"}
              direction={"row"}
              className="form"
            >
              <Grid item>
                <Box
                  sx={{ "& .MuiTextField-root": { m: 1, width: "30ch" } }}
                  autoComplete="off"
                >
                  <div>
                    <TextField
                      required
                      label="Access Key"
                      id="outlined-size-small"
                      size="small"
                      value={formData.accessKey}
                      onChange={(e) =>
                        handleInputChange("accessKey", e.target.value)
                      }
                    />
                  </div>
                </Box>
              </Grid>
              <Grid item container justifyContent={"center"} sm={12} md={12}>
                {/* <Typography >OR</Typography> */}
              </Grid>
              <Grid item>
                <Box
                  sx={{ "& .MuiTextField-root": { m: 1, width: "30ch" } }}
                  autoComplete="off"
                >
                  <div>
                    <TextField
                      required
                      label="Email ID"
                      id="outlined-size-small"
                      size="small"
                      value={formData.email}
                      onChange={(e) =>
                        handleInputChange("email", e.target.value)
                      }
                    />
                  </div>
                </Box>
              </Grid>

              <Grid item container justifyContent="end" alignItems="center">
                {/* <FormControlLabel control={<Checkbox />} label="Remember me" /> */}
                <Link href="/" underline="hover">
                  Back
                </Link>
              </Grid>
              <Grid
                item
                container
                alignItems="center"
                sx={{ marginTop: "1rem" }}
              >
                <Button
                  variant="contained"
                  type="submit"
                  // onClick={handleLogin}
                  style={{
                    backgroundColor: "#05CFD3",
                    color: "#fff",
                    borderRadius: "12px",
                    width: "100%"
                  }}
                >
                  <strong> SUBMIT </strong>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* right side  */}
        <Grid item md={6}>
          <Grid container>
            <Grid item className="rightSide">
              <Typography variant="h5" className="nuralTag">
                {/* <strong>Nural Service</strong> */}
              </Typography>
              <Grid container justifyContent={"center"} className="loginImage">
                <img src={LoginPageImage} alt="" className="img" />
              </Grid>
              <Grid
                container
                justifyContent={"center"}
                sx={{ padding: "10px" }}
                className="loginFooter"
              >
                <img src={loginFooter} alt="" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Toaster />
      {loading && <Loader />}
    </form>
  );
};

export default Loginpage;
